module.exports = __webpack_public_path__ + "static/media/Bastille-Day-18.35d7efc0.jpg";